module.exports = __webpack_public_path__ + "img/dashed-hr.4e1ac34e.svg";